export default "__VITE_ASSET__XHwdrRVq__"